<template>
  <div class="tree-wrapper">
    <el-tree
      ref="treeRef"
      :data="treeData"
      show-checkbox
      node-key="prop"
      default-expand-all
      :default-checked-keys="selectedProp"
      draggable
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      :props="defaultProps"
      @node-drag-end="handleDragEnd"
      @check="handleChange"
    >
      <span slot-scope="{ node }" class="custom-tree-node">
        <span>{{ node.label }}</span>
      </span>
    </el-tree>
  </div>
</template>
<script>
export default {
  name: 'Tree',
  props: {
    newColumn: {
      type: Array,
      default: () => []
    },
    selectedProp: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeData: [
        {
          label: this.$t('collectionCenter.allSelect'),
          prop: 'all',
          children: JSON.parse(JSON.stringify(this.newColumn))
        }
      ],
      selectedPropArr: JSON.parse(JSON.stringify(this.selectedProp))
    };
  },
  methods: {
    allowDrop(draggingNode, dropNode, type) {
      // 禁止拖拽根节点 "全部"
      if (draggingNode.data.prop === 'all') return false;

      // 获取拖拽节点和放置节点的父级
      const dragParent = draggingNode.parent;
      const dropParent = dropNode.parent;

      // 如果没有父级（根节点），不允许操作
      if (!dragParent || !dropParent) return false;

      // 关键：只有父节点完全相同（同一个父级）才允许拖拽放置
      // 即：拖拽节点和放置节点必须在同一个父节点下
      if (dragParent.data.prop !== dropParent.data.prop) {
        return false;
      }
      // 如果是 next/prev (同级排序)，允许
      if (type === 'next' || type === 'prev') {
        return true;
      }

      // 如果是 inner (放入内部)，不允许 —— 确保不能嵌套
      if (type === 'inner') {
        return false;
      }

      return false;
    },
    allowDrag(draggingNode) {
      // 不允许拖动根节点 "全部"
      return draggingNode.data.prop !== 'all';
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      // 拖拽结束后，恢复勾选状态
      this.$nextTick(() => {
        if (this.selectedPropArr && this.selectedPropArr.length > 0) {
          // 先清空所有勾选
          this.$refs.treeRef.setCheckedKeys([]);
          // 恢复之前保存的勾选状态
          this.$refs.treeRef.setCheckedKeys(this.selectedPropArr);
        }
      });
    },
    handleChange(data, node) {
      this.selectedPropArr = node.checkedKeys;
    },
    // 保存
    saveColumn() {
      localStorage.setItem('fundConsumptionSelectedProp', JSON.stringify(this.selectedPropArr));
      localStorage.setItem('fundConsumptionColumnList', JSON.stringify(this.treeData[0].children));
      this.$emit('saveColumn', this.treeData[0].children, this.selectedPropArr);
    }
  }
};
</script>

<style scoped>

</style>
